export default "__VITE_ASSET__ad53a933__"